import isNil from 'lodash/fp/isNil';
import { FormattedMessage } from 'react-intl';
import { Unit } from '../../../common/constants';
import {
    convertMetersIntoKilometers,
    convertSecondsIntoHHmmDisplay,
    convertStringToDateFormat,
    getBatteryColor,
    getBatteryIcon,
} from '../../../common/utils';
import { TimelineEventType } from '../../../store/facade/facadeApiV3';

export type DrivingInfo = {
    departure?: string;
    duration?: number;
    distance?: number;
    batteryPct?: number;
    type?: TimelineEventType;
};
type DrivingPanelProps = {
    driving: DrivingInfo;
};

export const DrivingPanel = ({ driving }: DrivingPanelProps) => {
    const isDriving = driving.type === TimelineEventType.Driving;
    const titleLabelId = isDriving ? 'intl-msg:glossary.activity.driving' : 'intl-msg:smartRoute.tour.transit';
    const date = convertStringToDateFormat(driving.departure);

    return (
        <li className='timeline-element' data-testid='timeline-element'>
            <div className='timeline-date margin-right-10'>
                <div className='border border-width-3 border-color-white'>
                    <span className='badge badge-lg badge-muted padding-5'>
                        <span
                            className={`rioglyph ${
                                isDriving ? 'rioglyph-status-driving' : 'rioglyph rioglyph-transfer'
                            }`}
                        />
                    </span>
                </div>
            </div>
            <div className='timeline-content margin-bottom-15'>
                <div className='text-medium text-size-16 text-color-darker margin-top-5 margin-bottom-5'>
                    <FormattedMessage id={titleLabelId} />
                </div>
                <div className='display-flex flex-column gap-2'>
                    <div>
                        <span className='rioglyph rioglyph-calendar text-color-gray margin-right-5' />
                        <span>{date}</span>
                    </div>
                    <div>
                        <span className='rioglyph rioglyph-time text-color-gray margin-right-5' />
                        {!isNil(driving.duration) ? (
                            <span>{convertSecondsIntoHHmmDisplay(driving.duration)}</span>
                        ) : (
                            '-'
                        )}
                    </div>

                    <div>
                        <span className='rioglyph rioglyph-route text-color-gray margin-right-5' />
                        {!isNil(driving.distance) ? (
                            <span>{`${convertMetersIntoKilometers(driving.distance)} ${Unit.km}`}</span>
                        ) : (
                            '-'
                        )}
                    </div>

                    {!isNil(driving.batteryPct) && (
                        <div className={`${getBatteryColor(driving.batteryPct)}`}>
                            <span className={`${getBatteryIcon(driving.batteryPct)} margin-right-5`} />
                            <span>{driving.batteryPct}</span>
                            <span>&nbsp;{Unit.pct}</span>
                        </div>
                    )}
                </div>
            </div>
        </li>
    );
};
